import Vue from 'vue'

const self = Vue.prototype

export default {

  getSettings() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.settings)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getFaq(page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.getFaq + `?page=${page}&per_page=${perPage}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
    })
  },
  removeFaq(id) {
    return new Promise((resolve, reject) => {
       self.axios.delete(self.$apiRouter.deleteFaq + id)
         .then(response => {
           resolve(response)
         })
         .catch(error => {
           reject(error)
         })
    })
  },

}
